// src/components/pages/journey/segmentComponent/SegmentFiltersCreate.js
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSegment } from "../../../../redux/actions/journeyAction";
import { Modal, Button, Form, Table } from "react-bootstrap";
import Page from "../../../Page";
import InlineFilters from "./InlineFilters";


const SegmentFiltersCreate = ({ pageTypeHandler, authToken }) => {
const dispatch = useDispatch();

useEffect(() => {
pageTypeHandler && pageTypeHandler("Segment");
}, [pageTypeHandler]);


return (
<>

<style>{`.header-div div { margin-top: 0px !IMPORTANT; }

  .filteres_div {
    padding: 80px; border-radius: 5px; box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid #e0e0e0;
    overflow: visible;
  }

  .custom_col {
      flex: 0 0 auto;
      padding: 2px;
      width: auto;
    }

    .custom_col .form-select {
      font-size:11px !important;
      padding: 8px 34px 8px 10px; /* leave space for custom caret */
      width: auto;
      min-width: 80px;
      max-width: 300px;
      font-family: 'Intee';
      font-style: normal;
      border: 1px solid #dce3ee; /* soft neutral */
      background-clip: padding-box;
      border-radius: 5px; /* rounded */
      background-color: #ffffff;
      /* custom chevron */
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      background-image:
        url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3E%3Cpath fill='%2389A1B6' d='M4.646 6.646a.5.5 0 0 1 .708 0L8 9.293l2.646-2.647a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 0-.708z'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: right 10px center;
      background-size: 16px 16px;
      box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
      transition: border-color .2s ease, box-shadow .2s ease, background-color .2s ease;
      padding: 2px 8px;
    }
 .custom_col .form-control {
      font-size:11px !important;
      padding: 4px 5px;
      width: auto;
      min-width: 80px;
      max-width: 180px;
      border-radius: 5px;
      border: 1px solid #dce3ee;
      box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
      transition: border-color .2s ease, box-shadow .2s ease;
    }

    /* Mobile responsiveness */
    @media (max-width: 768px) {
      .custom_col {
        flex: 1 1 auto;
        min-width: 100px;
        max-width: 100%;
        margin-bottom: 4px;
      }
      
      .custom_col .form-select,
      .custom_col .form-control {
        min-width: 100px;
        max-width: 100%;
        width: 100%;
      }
    }

    /* Tablet responsiveness */
    @media (min-width: 769px) and (max-width: 1024px) {
      .custom_col {
        min-width: 120px;
        max-width: 200px;
      }
      
      .custom_col .form-select,
      .custom_col .form-control {
        min-width: 120px;
        max-width: 200px;
      }
    }


.form-select:hover {
  border-color: #94bffb !important;
}
.form-select:focus {
  outline: none;
  border-color: #86b7fe !important;
  box-shadow: 0 0 0 3px rgba(13,110,253,.12) !important; /* soft focus ring */
}



/* Fix dropdown overlap issues */
.custom_col .form-select {
  position: relative;
  z-index: 30;
  margin-bottom: 1px; /* keep bottom border visible above neighbors */
}

.custom_col .form-select:focus {
  z-index: 10;
}

/* Ensure dropdown options don't overlap */
.custom_col .form-select option {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 8px 10px;
}

/* Add proper spacing between rows to prevent overlap */
.row-cols-auto {
  margin-bottom: 4px;
  position: relative;
  z-index: 1;
}

 @media (min-width: 1025px) {
    .col10 {
      flex: 0 0 auto;
      width: 11%;
      padding: 2px;
      width: auto;
    }
    .col10 .form-select {
      font-size:11px !important;
      padding: 5px;
      width: auto;
      min-width: 100px;
      max-width: 300px;
    }
    .col10 .form-control {
      font-size:11px !important;
      padding: 5px;
      width: auto;
      min-width: 100px;
      max-width: 180px;
    }
      
  }
  .segment_container{ padding: 5px 50px 50px 50px !important; background-color: #f8f8f8 !important; }
  .custom_total_users{ font-size: 12px !important; padding: 5px 55px !important; margin-left: 0px !important; border:1px solid #e0e0e0 !important; }

  /* Ensure no parent clips dropdowns */
  .segment_container, .container, .row, .row-cols-auto, .custom_col { overflow: visible !important; }

  /* Make tabs look like select/dropdown buttons */
.nav-tabs {
  border-bottom: none; /* remove underline */
}

/* NiceSelect styling */
.nice-select { position: relative; z-index: 5000; }
.nice-select__toggle {
  width: auto;
  min-width: 120px;
  max-width: 320px;
  padding: 3px 8px;
  font-size: 11px;
  border-radius: 5px;
  border: 1px solid #dce3ee;
  background-color: #fff;
  color: #111827;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
  cursor: pointer;
  outline: none;
}
.nice-select__toggle:hover {
  border-color: #0b66ff;
}
.nice-select__toggle:focus {
  border-color: #0b66ff;
  box-shadow: 0 0 0 2px rgba(11, 102, 255, 0.1);
}

.nice-select .dropdown-toggle:after { display: none; }
.nice-select__caret {
  width: 0; height: 0; margin-left: 8px;
  border-left: 5px solid transparent; border-right: 5px solid transparent; border-top: 6px solid #89A1B6;
}
.nice-select__menu {
  padding: 2px;
  border-radius: 5px;
  border: 1px solid #e6ecf4;
  box-shadow: 0 8px 20px rgba(16,24,40,0.12);
  background-color: #fff;
  max-height: 200px;
  overflow-y: auto;
  transform-origin: top left;
}

.nice-select__item { 
  font-size: 12px; 
  border-radius: 5px; 
  padding: 5px; 
  cursor: pointer;
  transition: background-color 150ms ease;
}
.nice-select__item.active, 
.nice-select__item:active, 
.nice-select__item:hover { 
  background-color: #f1f6ff; 
  color: #0b66ff; 
}
.nice-select__empty { 
  padding: 8px 10px; 
  color: #6b7280; 
  font-size: 12px; 
}

@keyframes ns-fade-in {
  from { opacity: 0; transform: scale(0.98); }
  to { opacity: 1; transform: scale(1); }
}




`}</style>
  <Page title="Segments">
    <div className="container p-5 segment_container">
      <InlineFilters 
        authToken={authToken}
        id={null} // or pass specific id if needed
      />
    </div>
 

  </Page>

</>
);
};

export default SegmentFiltersCreate;